import { Injectable, OnDestroy, inject } from '@angular/core';
import { ENV_CONFIG } from '@core/config/env.token';
import { CheckoutSyncService } from './checkout-sync.service';
import { LogService } from './log.service';

@Injectable({ providedIn: 'root' })
export class CheckoutSyncJobService implements OnDestroy {
  private readonly config = inject(ENV_CONFIG);
  private readonly checkoutSync = inject(CheckoutSyncService);
  private readonly logger = inject(LogService);
  private intervalId: number | null = null;

  constructor() {
    this.start();
  }

  start(): void {
    if (this.intervalId !== null) {
      return;
    }
    const interval = Math.max(this.config.checkoutSyncIntervalMs || 60000, 15000);
    this.intervalId = window.setInterval(() => {
      this.checkoutSync.syncPendingJob()
        .catch(error => {
          this.logger.warn('CheckoutSyncJob: error en reintento', {
            error: error instanceof Error ? error.message : String(error)
          });
        });
    }, interval);
  }

  stop(): void {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  ngOnDestroy(): void {
    this.stop();
  }
}
